import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AppBar, APP } from "../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../components/desktopUi";
import { appImages } from "../assets/appicons";

// Trang "Đang bảo trì" - khớp app, dùng cho các chức năng chưa clone
const Maintenance = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const pageBody = (
    <>
      <Flex direction="column" align="center" justify="center" minH="calc(100dvh - 52px)" px="24px">
        <img
          src={appImages.icon_maintenance}
          alt=""
          width={220}
          height={220}
          style={{ objectFit: "contain" }}
        />
        <Text mt="12px" fontSize="20px" fontWeight={800} color={APP.primary200} textAlign="center">
          Đang bảo trì
        </Text>
        <Text mt="8px" maxW="300px" fontSize="14px" color={APP.gray} textAlign="center">
          Hiện tại chức năng này đang trong quá trình xây dựng và bảo trì
        </Text>
      </Flex>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title="Quay lại" right={<DesktopBack onClick={() => navigate(-1)} />}>
        <DesktopPanel p="0" pb="24px">
          {pageBody}
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" bg={APP.surface} minH="100dvh">
      <AppBar title="Quay lại" onBack={() => navigate(-1)} />
      {pageBody}
    </Box>
  );
};

export default Maintenance;
